export const WeatherEffectEnum = Object.freeze({
    rainy: 'rainy',
    snowy: 'snowy',
    sunny: 'sunny',
    cloudy: 'cloudy',
    live: 'live',
    none: 'none',
})